export var LAST_ACTIVITY_TIMESTAMP_KEY = 'idleLastActivityTimestamp';
export function getLastActivityTimestamp() {
    var parsed = parseInt(localStorage.getItem(LAST_ACTIVITY_TIMESTAMP_KEY) || '');
    return isNaN(parsed) ? 0 : parsed;
}
export function updateLastActivityTimestamp(timestamp) {
    var _a;
    localStorage.setItem(LAST_ACTIVITY_TIMESTAMP_KEY, (_a = timestamp === null || timestamp === void 0 ? void 0 : timestamp.toString()) !== null && _a !== void 0 ? _a : Date.now().toString());
}
